<template>
  <Card
    tone="accent"
    padding="lg"
    class="grid gap-6 md:grid-cols-[minmax(0,0.85fr)_minmax(0,1fr)] md:items-center"
    data-testid="lead-magnet"
  >
    <div class="flex flex-col gap-3">
      <div class="flex items-center gap-3">
        <span
          class="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-accent text-ink-inverse"
        >
          <BaseIcon name="check" :size="24" />
        </span>
        <span v-if="fileLabel" class="text-xs font-semibold text-accent-strong">
          {{ fileLabel }}
        </span>
      </div>
      <h3 class="text-xl font-extrabold text-ink-strong md:text-2xl">{{ heading }}</h3>
      <p class="text-sm text-ink md:text-base">{{ description }}</p>
    </div>

    <LeadForm
      source="home.leadMagnet"
      :fields="['email']"
      :submit-label="ctaLabel"
      @submitted="submittedFrom"
    />
  </Card>
</template>

<script setup lang="ts">
import Card from '@/components/primitives/Card.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';
import LeadForm from '@/components/domain/LeadForm.vue';
import { SubmitResult } from '@/types/types';
import { LeadFormFieldKey, LeadFormValues } from '@/lib/forms/buildLeadPayload';

interface Props {
  heading: string;
  description: string;
  fileLabel?: string;
  ctaLabel: string;
}

withDefaults(defineProps<Props>(), {
  fileLabel: '',
});

const emit = defineEmits<{
  (e: 'submit', payload: { readonly email: string }): void;
}>();

const submittedFrom = (payload: {
  result: SubmitResult;
  fields: LeadFormValues;
  keys: readonly LeadFormFieldKey[];
}) => {
  emit('submit', { email: payload.fields['email'] });
};
</script>
